export enum ActionType {
  START_LOADING = 'START_LOADING',
  STOP_LOADING = 'STOP_LOADING',
  START_GLOBAL_LOADING = 'START_GLOBAL_LOADING',
  STOP_GLOBAL_LOADING = 'STOP_GLOBAL_LOADING',
  SET_ERROR = 'SET_ERROR',
  CLEAR_ERROR = 'CLEAR_ERROR',
}
